import React from "react";
import { useNavigate } from "react-router-dom";

import heroImage from "../assets/blog.png";

import gridImage from "../assets/grid4.png";
import robotImage from "../assets/5.jpg";
import salaryImage from "../assets/6.jpg";
import automateImg from "../assets/automating.png";
import aiCatalogImg from "../assets/300.png";

import gstrImg from "../assets/gstr.png";

const styles = `
  * { box-sizing: border-box; }

  .blogs-page-wrapper {
    background: #24c7b8;
    min-height: 100vh;
    padding-bottom: 80px;
  }

  /* ── HERO ── */
  .blogs-hero {
    width: 100%;
    max-width: 1200px;
    margin: 5px auto 90px;
    background: #173b8f;
    border-radius: 16px;
    padding: 48px 52px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 48px;
  }

  .blogs-hero-text {
    flex: 1 1 0;
    min-width: 0;
  }

  .blogs-hero-title {
    color: #fff;
    font-size: 46px;
    font-weight: 700;
    margin-bottom: 20px;
    font-family: "Exo", sans-serif;
    line-height: 1.15;
    letter-spacing: -0.5px;
  }

  .blogs-hero-desc {
    color: rgba(255, 255, 255, 0.85);
    font-size: 16px;
    line-height: 1.85;
    max-width: 460px;
    margin: 0;
  }

  .blogs-hero-btn {
    margin-top: 28px;
    background: #2f6df6;
    color: #fff;
    border: none;
    padding: 13px 28px;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    display: inline-block;
    letter-spacing: 0.2px;
  }

  /* ── IMAGE WRAPPER — key fix ── */
  .blogs-hero-img-wrap {
    flex: 0 0 auto;
    width: 480px;
    max-width: 48%;
  }

  .blogs-hero-img {
    width: 100%;
    height: 300px;
    border-radius: 12px;
    object-fit: cover;
    object-position: center;
    display: block;
  }

  /* ── GRIDS ── */
  .blogs-grid-wrapper {
    width: 95%;
    max-width: 1700px;
    margin: 0 auto 40px;
  }

  .blogs-grid-wrapper-bottom {
    width: 95%;
    max-width: 1700px;
    margin: 0 auto;
  }

  .blogs-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 26px;
  }

  /* ── CARD ── */
  .blogs-card {
    background: #173b8f;
    border-radius: 18px;
    overflow: hidden;
    cursor: pointer;
    display: flex;
    flex-direction: column;
  }

  .blogs-card-img {
    width: 100%;
    height: 250px;
    object-fit: cover;
    display: block;
    flex-shrink: 0;
  }

  .blogs-card-body {
    padding: 28px;
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .blogs-card-title {
    color: #fff;
    font-size: 20px;
    line-height: 1.8;
    font-weight: 700;
    margin-bottom: 22px;
    font-family: "Exo", sans-serif;
  }

  .blogs-card-title-upper {
    color: #fff;
    font-size: 20px;
    line-height: 1.8;
    font-weight: 700;
    text-transform: uppercase;
    margin-bottom: 22px;
    font-family: "Exo", sans-serif;
  }

  .blogs-card-desc {
    color: #f2f2f2;
    font-size: 17px;
    line-height: 1.9;
    margin-bottom: 28px;
    flex: 1;
  }

  .blogs-card-btn {
    background: #2f6df6;
    color: #fff;
    border: none;
    padding: 13px 26px;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    align-self: flex-start;
  }

  /* ── TABLET: 901px – 1023px ── */
  @media (max-width: 1023px) {
    .blogs-grid {
      grid-template-columns: repeat(2, 1fr);
    }

    .blogs-hero-title {
      font-size: 36px;
    }

    .blogs-hero {
      margin-bottom: 50px;
      padding: 36px 36px;
      gap: 32px;
    }

    .blogs-hero-img-wrap {
      width: 420px;
      max-width: 46%;
    }

    .blogs-hero-img {
      height: 270px;
    }
  }

  /* ── TABLET PORTRAIT: up to 900px ── */
  @media (max-width: 900px) {
    .blogs-hero {
      flex-direction: column;
      padding: 32px 28px;
      gap: 28px;
      margin-bottom: 40px;
    }

    .blogs-hero-text {
      width: 100%;
    }

    .blogs-hero-img-wrap {
      width: 100%;
      max-width: 100%;
    }

    .blogs-hero-img {
      height: 260px;
    }

    .blogs-hero-desc {
      max-width: 100%;
    }

    .blogs-hero-title {
      font-size: 32px;
    }
  }

  /* ── MOBILE: up to 767px ── */
  @media (max-width: 767px) {
    .blogs-page-wrapper {
      padding-bottom: 50px;
    }

    .blogs-hero {
      padding: 24px 20px;
      margin: 0 0 36px;
    }

    .blogs-hero-title {
      font-size: 28px;
      margin-bottom: 14px;
    }

    .blogs-hero-desc {
      font-size: 15px;
      line-height: 1.75;
    }

    .blogs-hero-btn {
      margin-top: 20px;
      width: 100%;
      text-align: center;
      padding: 13px 20px;
    }

    .blogs-hero-img {
      height: 220px;
    }

    .blogs-grid {
      grid-template-columns: 1fr;
    }

    .blogs-grid-wrapper,
    .blogs-grid-wrapper-bottom {
      width: 92%;
    }

    .blogs-grid-wrapper {
      margin-bottom: 28px;
    }

    .blogs-card-img {
      height: 200px;
    }

    .blogs-card-body {
      padding: 20px;
    }

    .blogs-card-title,
    .blogs-card-title-upper {
      font-size: 17px;
      margin-bottom: 14px;
    }

    .blogs-card-desc {
      font-size: 15px;
      margin-bottom: 20px;
    }

    .blogs-card-btn {
      width: 100%;
      text-align: center;
    }
  }

  /* ── SMALL MOBILE: up to 480px ── */
  @media (max-width: 480px) {
    .blogs-hero-title {
      font-size: 24px;
    }

    .blogs-hero {
      padding: 20px 16px;
    }

    .blogs-hero-img {
      height: 190px;
    }

    .blogs-grid-wrapper,
    .blogs-grid-wrapper-bottom {
      width: 96%;
    }

    .blogs-card-img {
      height: 170px;
    }
  }
`;

const BlogsPage = () => {
  const navigate = useNavigate();

  const topBlogs = [
    {
      title: "GSTR Reconciliation",
      description:
        "Every month, the Organization performs statutory and financial reporting activities including outward supplies and tax liability reconciliation.",
      image: gstrImg,
      link: "/blogs/gstr-reconciliation",
    },
    {
      title:
        "Automating Purchase & Sales Invoice Entry into SAP: A Research Guide to Document AI, APIs and LLMs",
      description:
        "Automating supplier purchase invoices and customer sales bills into SAP using OCR, APIs and intelligent automation workflows.",
      image: automateImg,
      link: "/blogs/sap-automation",
    },
    {
      title: "300+ AI, GenAI, LLM & AI Agent Technologies – The Ultimate Catalog",
      description:
        "Comprehensive catalog covering GenAI, LLM tooling, AI Agents, Vision, Speech and Cloud AI technologies with practical enterprise use cases.",
      image: aiCatalogImg,
      link: "/blogs/ai-catalog",
    },
  ];

  const bottomBlogs = [
    {
      title:
        "Future Of RPA As Per Analysts, Current Challenges Of RPA And Its Applications",
      description:
        "Robotic Process Automation is rapidly growing across industries and transforming business operations worldwide.",
      image: gridImage,
      link: "/blogs/future-of-rpa",
    },
    {
      title: "Robotic Process Automation Training Using Ui-Path",
      description:
        "Learn the basics of UiPath workflows, automation concepts and enterprise RPA implementation practices.",
      image: robotImage,
      link: "/blogs/uipath-training",
    },
    {
      title: "RPA Salary Trends And Why The Consultant Rates Are Hyped",
      description:
        "Explore current RPA market trends, salary demand and enterprise consultant opportunities globally.",
      image: salaryImage,
      link: "/blogs/rpa-salary-trends",
    },
  ];

  return (
    <>
      <style>{styles}</style>

      <div className="blogs-page-wrapper">

        {/* ── HERO ── */}
        <div className="blogs-hero">
          <div className="blogs-hero-text">
            <h1 className="blogs-hero-title">Ai Agents</h1>
            <p className="blogs-hero-desc">
              AI agents are autonomous software systems capable of perceiving
              their surroundings, and taking action to achieve specific goals.
              But what exactly are AI agents? How do they function, and how can
              we live alongside them — not in fear, but in partnership?
            </p>
            <button
              className="blogs-hero-btn"
              onClick={() => navigate("/blog/ai-agents")}
            >
              Learn more
            </button>
          </div>

          {/* ── IMAGE WRAPPER ── */}
          <div className="blogs-hero-img-wrap">
            <img
              src={heroImage}
              alt="AI"
              className="blogs-hero-img"
            />
          </div>
        </div>

        {/* ── TOP BLOGS ── */}
        <div className="blogs-grid-wrapper">
          <div className="blogs-grid">
            {topBlogs.map((blog, index) => (
              <div
                key={index}
                className="blogs-card"
                onClick={() => navigate(blog.link)}
              >
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="blogs-card-img"
                />
                <div className="blogs-card-body">
                  <h2 className="blogs-card-title">{blog.title}</h2>
                  <p className="blogs-card-desc">{blog.description}</p>
                  <button className="blogs-card-btn">Learn more</button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ── BOTTOM BLOGS ── */}
        <div className="blogs-grid-wrapper-bottom">
          <div className="blogs-grid">
            {bottomBlogs.map((blog, index) => (
              <div
                key={index}
                className="blogs-card"
                onClick={() => navigate(blog.link)}
              >
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="blogs-card-img"
                />
                <div className="blogs-card-body">
                  <h2 className="blogs-card-title-upper">{blog.title}</h2>
                  <p className="blogs-card-desc">{blog.description}</p>
                  <button
                    className="blogs-card-btn"
                    onClick={(e) => e.stopPropagation()}
                  >
                    Learn more
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </>
  );
};

export default BlogsPage;
